/**
 * What this app lends the package's sharing screens (`SharingHostProps`): the
 * organisation's members from **core-org-management's** directory (read with
 * this app's session, never copied — constitution §1), the shell's step-up
 * (`StepUpDialog`), and where a link opens — this app's own origin, which
 * serves `/s/<token>` outside the session guard.
 *
 * Identities are stable per organisation, so the package's loaders do not
 * re-read on every render.
 */

import type { ShareMember, SharingHostProps } from '@fiveox/prodoc-ui'
import { useCallback, useMemo } from 'react'

import { fetchOrgMembers } from '../lib/orgs'
import { useOrg } from './org-context'
import { useStepUp } from './StepUpDialog'

export function useSharingHost(): SharingHostProps {
  const { org } = useOrg()
  const requestStepUp = useStepUp()
  const listMembers = useCallback(
    async (): Promise<ShareMember[]> => (await fetchOrgMembers(org.id)).map((m) => ({ user_id: m.user_id, name: m.full_name, email: m.email })),
    [org.id],
  )
  return useMemo(() => ({ listMembers, requestStepUp, shareLinkBase: window.location.origin }), [listMembers, requestStepUp])
}
